import { HttpTokens, GetIncidentProgress } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description get incident progress by id
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const IncidentProgressGet = (
  /** create can also refer to update for draft */
  prefix: string = 'incidents/progress',
  id: string,
  tokens: HttpTokens,
  hardRejection = true
): Promise<GetIncidentProgress> => {
  const instance = new AxiosService({ method: 'get', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  return instance.client
    .get(`${prefix}/${id}`, config)
    .then((d: AxiosResponse<GetIncidentProgress>) => {
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<GetIncidentProgress>;
};
